require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-deutsch-jahrndorf.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-deutsch-jahrndorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-deutsch-jahrndorf!./.cache/json/betreuungseinrichtungen-neusiedl-deutsch-jahrndorf.json
// module id = 946
// module chunks = 231608221292675